export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33')
];

export const server_loads = [];

export const dictionary = {
		"/": [~2],
		"/404.html": [3],
		"/alternate-reality/[slug]": [6],
		"/future/[slug]": [7],
		"/playground/accords": [8],
		"/playground/app-review-links": [9],
		"/playground/au-hasard": [10],
		"/playground/audio": [11],
		"/playground/bigeditabletext": [12],
		"/playground/blabla": [13],
		"/playground/box-timer": [14],
		"/playground/chrono": [15],
		"/playground/dev-tools": [16],
		"/playground/eliza": [17],
		"/playground/falling-money": [18],
		"/playground/jwt": [19],
		"/playground/looper": [20],
		"/playground/md": [21],
		"/playground/poker-planning": [22],
		"/playground/poll": [23],
		"/playground/poupoulse": [24],
		"/playground/simple-module-example": [25],
		"/playground/tab-counter": [26],
		"/playground/tabasse": [27],
		"/playground/time-boxing": [28],
		"/playground/typing-train": [29],
		"/playground/walking-bass": [30],
		"/playground/web-components": [31],
		"/privacy-policy": [32],
		"/vdi": [33],
		"/[slug]": [4],
		"/[year]/[month]/[day]": [5]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);